// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import taskChecklistItemEntity from './entities/task-checklist-item.json';
import taskChecklistItemMenu from '../pages/task-checklist-item/menu.json';
import taskChecklistItemFullForm from '../pages/task-checklist-item/forms/full.json';
import taskChecklistItemContextForm from '../pages/task-checklist-item/forms/context.json';
import taskChecklistItemMiniForm from '../pages/task-checklist-item/forms/mini.json';
import taskChecklistItemLookupForm from '../pages/task-checklist-item/forms/lookup.json';
import taskChecklistItemTableView from '../pages/task-checklist-item/views/table.json';
import taskChecklistItemCardsView from '../pages/task-checklist-item/views/cards.json';
import taskChecklistItemDashboardView from '../pages/task-checklist-item/views/dashboard.json';

/** Тип запису «Пункт чек-листа» зі сторінками пакета: меню, форми та подання з pages/task-checklist-item/. */
export const taskChecklistItemDefinition: IRecordTypeDefinition = {
  ...taskChecklistItemEntity,
  views: assembleViewSet({
      table: taskChecklistItemTableView,
      cards: taskChecklistItemCardsView,
      dashboard: taskChecklistItemDashboardView,
  }),
  form: taskChecklistItemFullForm,
  forms: { full: taskChecklistItemFullForm, context: taskChecklistItemContextForm, mini: taskChecklistItemMiniForm, lookup: taskChecklistItemLookupForm },
  menu: taskChecklistItemMenu,
} as IRecordTypeDefinition;
